import LabelChip from "../../../../components/shared/labelChip/labelChip";
import { LabelChipClassType } from "../../../../components/shared/labelChip/types/labelChipProps";

const CollectiveLabelChip = (props: { isAuto: boolean, labelClass?: string }) => {
    const labelClass = props.labelClass ? props.labelClass : "collective-label"
    return props.isAuto ?
        <LabelChip text="Pole uzupełniane automatycznie" mainClass={`${labelClass} ${LabelChipClassType.Secondary}`} /> :
        <LabelChip text="Pole uzupełniane przez użytkownika" mainClass={`${labelClass} ${LabelChipClassType.Primary}`} />
}

export default CollectiveLabelChip;